import { Component, computed, inject, OnInit, viewChild } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { FooterComponent } from './components/footer.component';
import { HeaderComponent } from './components/header.component';
import {
  SynAlertComponent,
  SynIconComponent,
} from '@synergy-design-system/angular';
import { errorMessage, hasError, clearError } from '../errors';
import { NgStyle } from '@angular/common';
import { NAV_BAR_MARGIN_OPEN, SideNavComponent } from './components/side-nav.component';


@Component({
  selector: 'app-root',
  imports: [RouterOutlet, HeaderComponent, FooterComponent, SynAlertComponent, SynIconComponent, NgStyle, SideNavComponent],
  template: `
    <div class="box full-page">
      <div class="header">
        <app-header />
      </div>


      <div class="main">
        <app-side-nav #sideNav />

        <div class="transition" [ngStyle]="contentStyle()" style="height: 80vh; overflow-y: auto">
          <div class="content">
            <syn-alert [open]="hasError()" (synHideEvent)="onHideAlert()" variant="danger" [closable]="true">
              <syn-icon name="error_fill" slot="icon" />
              {{ errorMessage() }}
            </syn-alert>

            <div class="flex-grow-1">
              <router-outlet />
            </div>
          </div>

          <div style="margin-top: auto">
            <app-footer />
          </div>
        </div>
      </div>


    </div>
  `,
  styles: [`
    .box {
      display: flex;
      flex-flow: column;
      min-height: 100vh;
      max-height: 100vh;
    }

    .box .header {
      flex-grow: 0;
      flex-shrink: 1;
      flex-basis: auto;
    }

    .box .main {
      display: flex;
      flex: 1 0 auto;
      flex-direction: column;
      height: 1%;
      position: relative;
    }

    .transition {
      transition: margin 250ms;
      flex-grow: 1;
      display: flex;
      flex-direction: column;
    }
  `],
})
export class AppComponent implements OnInit {
  title = 'frontend';

  protected readonly hasError = hasError;
  protected readonly errorMessage = errorMessage;

  sideNav = viewChild<SideNavComponent>('sideNav');
  contentStyle = computed(() => {
    const sideNav = this.sideNav();
    if (!sideNav) return NAV_BAR_MARGIN_OPEN;
    return sideNav.contentStyle();
  });

  router = inject(Router);

  ngOnInit() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.errorMessage.set(null);
      }
    });
  }

  onHideAlert() {
    // clear error message, so that the signal gets triggered again if a new error occurs
    clearError();
  }
}
